// Port of api/fuel/app/classes/filter/search/users/sorts/query/plays.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'plays',
	post: false,
	require: function(config, filter) { return sorted('plays', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('u.user_count_plays', sortReverse('plays', filter), sortPriority('plays', filter))
	}
}
